const VERSION: string = '0.1.7-prod.102'
export default VERSION;
